const provinceJapaneseNames = {
  Aichi: '愛知県',
  Akita: '秋田 県',
  Aomori: '青森県',
  Chiba: '千葉県',
  Ehime: '愛 媛県',
  Fukui: '福井県',
  Fukuoka: '福岡県',
  Fukushima: '福島県',
  Gifu: '岐阜県',
  Gunma: '群馬県',
  Hiroshima: '広島県',
  Hokkaidō: '北海 道',
  Hyōgo: '兵庫県',
  Ibaraki: '茨城県',
  Ishikawa: '石川県',
  Iwate: '岩手県',
  Kagawa: '香川県',
  Yamanashi: '山梨県',
  Yamaguchi: '山口県',
  Kōchi: '高知県',
  Kumamoto: '熊本県',
  Kyōto: '京都府',
  Mie: '三重県',
  Yamagata: '山形県',
  Miyazaki: '宮崎県',
  Nagano: '長野県',
  Nagasaki: '長崎県',
  Nara: '奈良県',
  Niigata: '新潟県',
  Ōita: '大分県',
  Okayama: '岡山県',
  Okinawa: '沖縄県',
  Ōsaka: '大阪府',
  Saga: '佐賀 県',
  Saitama: '埼玉県',
  Shiga: '滋賀県',
  Shimane: '島根県',
  Shizuoka: '静岡県',
  Tochigi: '栃木県',
  Tokushima: '徳島県',
  Tottori: '鳥取県',
  Toyama: '富山県',
  Tōkyō: '東京都',
  Miyagi: '宮城県',
  Wakayama: '和 歌山県',
  Kanagawa: '神奈川県',
  Kagoshima: '鹿児島県',
};

/**
 *
 * @param {String} provinceName
 */
const myFunc = (provinceName) => {
  if (!provinceName) {
    return '';
  }

  const provinceJapaneseNamesKeys = Object.keys(provinceJapaneseNames);

  let finalProvinceName = provinceName;

  provinceJapaneseNamesKeys.forEach((singleKey) => {
    finalProvinceName = finalProvinceName.replace(
      singleKey,
      provinceJapaneseNames[singleKey]
    );
  });

  return finalProvinceName;
};

export default myFunc;
